import {postMessage} from '../../frame/FrameActions';

/**
 * Přenačte vrstvu.
 *
 * @param {string} area - oblast store
 * @param {string} id - ID vrstvy
 * @returns {Object} akce
 */
export function reloadLayer(area: string, id: string) {
    return postMessage(area, {type: 'RELOAD_LAYER', id});
}
